import { ChangeEvent, useId } from 'react';
import { P, match } from 'ts-pattern';
import * as S from './styles';

export interface ChipButtonItem {
  text: string;
  value: string;
}

interface Props {
  options: ChipButtonItem[] | string[];
  selectedValue?: string | string[];
  onChange?: (value: string) => void;
  flexWrap?: boolean;
}

export default function ChipButtons({
  options,
  selectedValue,
  onChange,
  flexWrap = false
}: Props) {
  const radioName = useId();

  const isMultiple = Array.isArray(selectedValue);

  const getItemValue = (
    obj: string | ChipButtonItem,
    key: keyof ChipButtonItem
  ) => {
    if (typeof obj === 'string') {
      return obj;
    }

    return obj[key];
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (onChange) {
      onChange(value);
    }
  };

  if (options?.length === 0) {
    return null;
  }

  return (
    <S.Wrapper
      style={
        flexWrap
          ? {
              overflowX: 'hidden',
              flexWrap: 'wrap',
              gap: '12px 8px'
            }
          : {}
      }
    >
      {options.map(item => {
        // 선택된 값이 하나이거나 여러개인지 확인
        const checked = match(selectedValue)
          .returnType<boolean>()
          .with(P.string, value => value === getItemValue(item, 'value'))
          .with(P.array(P.string), value =>
            value.includes(getItemValue(item, 'value'))
          )
          .otherwise(() => false);

        return (
          <S.ChipItem key={getItemValue(item, 'value')}>
            <S.Input
              type={isMultiple ? 'checkbox' : 'radio'}
              id={`chip-${getItemValue(item, 'value')}`}
              name={radioName}
              value={getItemValue(item, 'value')}
              checked={checked}
              onChange={handleChange}
            />
            <S.ChipButton htmlFor={`chip-${getItemValue(item, 'value')}`}>
              {getItemValue(item, 'text')}
            </S.ChipButton>
          </S.ChipItem>
        );
      })}
    </S.Wrapper>
  );
}
